export default __webpack_public_path__ + "static/blooming_desire_1-0e8d23f6d784e5b1adca2daf49a9ad5e.png";